module.exports = __webpack_public_path__ + "static/media/coin.e2f22945.png";